export default "__VITE_ASSET__8459e0c9__"